import { type ComponentProps } from "react";

export const LightRain = (props: ComponentProps<"svg">) => (
  <svg
    width="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 23.9572C27.375 23.57 30 20.6028 30 17C30 13.134 26.9776 10 23.2493 10C23.1054 10 22.9626 10.0047 22.821 10.0139C21.5661 5.38976 17.469 2 12.6083 2C6.74949 2 2 6.92487 2 13C2 18.1419 5.40237 22.4598 10 23.665V21.5772C6.55261 20.4291 4 17.0657 4 13C4 7.96046 7.92179 4 12.6083 4C16.5839 4 20.0091 6.85004 20.9569 10.7911L20.9599 10.7899C21.0937 11.3367 21.1791 11.9037 21.2108 12.4855C21.8339 12.1732 22.5272 12 23.2493 12C25.8053 12 28 14.1696 28 17C28 19.5486 26.2205 21.5615 24 21.937V23.9572ZM13.5021 28.0021C13.7442 28.0021 14.0022 27.7921 14.0021 27.456C14.0021 27.272 13.9389 26.9263 13.7435 26.4168C13.6656 26.2136 13.5746 26.0045 13.4744 25.7938C13.1753 26.4437 13.0015 27.0277 13.0017 27.456C13.0018 27.7921 13.2599 28.0021 13.5021 28.0021ZM12.2923 23.7572C12.9029 22.7302 13.5002 22 13.5002 22C13.5002 22 14.0699 22.7554 14.6655 23.7778C15.318 24.8977 16.0018 26.3379 16.0021 27.456C16.0025 28.8622 14.8835 30.0021 13.5027 30.0021C12.1218 30.0021 11.0021 28.8622 11.0017 27.456C11.0013 26.229 11.654 24.8309 12.2923 23.7572ZM20.0021 24.456C20.0022 24.7921 19.7442 25.0021 19.5021 25.0021C19.2599 25.0021 19.0018 24.7921 19.0017 24.456C19.0015 24.0277 19.1753 23.4437 19.4744 22.7938C19.5746 23.0045 19.6656 23.2136 19.7435 23.4168C19.9389 23.9263 20.0021 24.272 20.0021 24.456ZM19.5002 19C19.5002 19 18.9029 19.7302 18.2923 20.7572C17.654 21.8309 17.0013 23.229 17.0017 24.456C17.0021 25.8622 18.1218 27.0021 19.5027 27.0021C20.8835 27.0021 22.0025 25.8622 22.0021 24.456C22.0018 23.3379 21.318 21.8977 20.6655 20.7778C20.0699 19.7554 19.5002 19 19.5002 19Z"
      fill="url(#paint0_linear_3029_21408)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3029_21408"
        x1="16"
        y1="2"
        x2="16"
        y2="30.0021"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#95B6F6" />
        <stop offset="1" stopColor="#5193DE" />
      </linearGradient>
    </defs>
  </svg>
);
